import { useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { useAFBFunction } from "./useAFBFunction";
import { useDialog } from "@albo-ui/core";

export const useAFBActionExecute = (changeAlert: ChangeAlertCallbackType, changePage: Function) => {
    const { handleAlboQuery, handleResendEmail, handleRestoreSession, handleOtpTokenGetAllowed, HandleOtpTokenDisabledConfirm } = useAFBFunction(changeAlert);

    const dialogProps = useDialog();
    const [action, setSAction] = useState("");
    const [element, setElement] = useState(null);
    const [dialogText, setDialogText] = useState({});
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const onOpenConfirm = (row, action) => {
        setItem(JSON.parse(JSON.stringify(row)));

        switch (action) {
            case "resendEmail":
                setElement([{
                        type: "textField",
                        label: "UUID",
                        key: "session_uuid",
                        text: "Por favor ingresa el UUID de la sesión para continuar.",
                }]);
                setDialogText({
                    title: "Reenviar correo",
                    message: "¿Estás seguro que deseas reenviar el correo de confirmación 3FA al siguiente Administrador?",
                });
                break;
            case "restoreSession":
                let checkOptions = [
                    {
                        label: "Sí soy yo el que intentó ingresar a mi cuenta",
                        value: "whitelist",
                        color: "info",
                    },
                    {
                        label: "No soy yo quien está intentando ingresar a mi cuenta",
                        value: "blacklist",
                        color: "warning",
                    },
                ];
                setElement([
                    { type: "textField", label: "UUID", key: "session_uuid" },
                    { type: "checkBox", options: checkOptions, key: "action" },
                ]);
                setDialogText({
                    title: "Validar sesión",
                    message: "A continuación complete el UUID de la sesión e indique si es válida para el siguiente Administrador",
                });
                break;
            case "resendEmailCS":
                setDialogText({
                    title: "Reenviar correo",
                    message: "¿Estás seguro que deseas reenviar el correo de confirmación 3FA al siguiente Administrador?",
                });
                break;
            case "otpTokenDisabledConfirm":
                setDialogText({
                    title: "¿Estás seguro que deseas desvincular el albo token?",
                    message: "Al desvincular el albo token, el usuario perderá acceso. Será necesario vincularlo nuevamente para poder utilizarlo de nuevo.",
                });
                break;
            case "alboToken":
                setDialogText({
                    title: "¿Estás seguro que deseas habilitar albo token?",
                    message: "Se habilitará albo token en la plataforma para autorizar las operaciones al siguiente cliente.",
                    cancelButton: "No, cancelar",
                    confirmButton: "Sí, habilitar",
                });
                break;
            case "alboTokenByEmail":
                setDialogText({
                    title: "¿Estás seguro que deseas activar albo token vía email?",
                    message: "A continuación se enviará un código de autenticación al cliente para vincular albo token vía email.",
                    cancelButton: "No, cancelar",
                    confirmButton: "Sí, vincular",
                });
                break;
        }
        
        setSAction(JSON.parse(JSON.stringify(action)));
        dialogProps.openDialog();
    };
    const onHandleConfirm = (result) => {
        dialogProps.onClose();
        switch (action) {
            case "resendEmail":
                return resendEmail(result);
            case "restoreSession":
                return restoreSession(result);
            case "resendEmailCS":
                return resendEmailCS();
            case "otpTokenDisabledConfirm":
                return otpTokenDisabledConfirm();
            case "alboToken":
                return onInsertAlboToken();
            case "alboTokenByEmail":
                return onInsertAlboTokenByEmail();
        }
    };

    const dataReuse = async (uuid) => {
        setLoading(true);

        let user = JSON.parse(localStorage.session);
        let data = {
            aql: `from data_reuse_afb where admin_uuid=${uuid}`,
            agent: user["uuid"],
        };

        let resp = await handleAlboQuery(data);
        if (resp) {
            changeAlert(true, "success", "Los datos del administrador fueron liberados exitosamente.");
            await changePage(null, 0);
        }

        setLoading(false);
    };

    const onInsertAlboToken = async (row?) => {
        setLoading(true);

        let user = JSON.parse(localStorage.session);
        let data = {
            aql: `from feature_insert_albo_token where uuids=${row ? row.uuid : item.uuid}`,
            agent: user["uuid"],
        };

        let resp = await handleAlboQuery(data);
        if (resp) {
            changeAlert(true, "success", "La habilitación de albo Token se realizó exitosamente.");
            await changePage(null, 0);
        }
        setLoading(false);
    };

    const onInsertAlboTokenByEmail = async () => {
        setLoading(true);

        let user = JSON.parse(localStorage.session);
        let data = {
            aql: `from feature_insert_albo_token_by_email where uuids=${item.uuid}`,
            agent: user["uuid"],
        };

        let resp = await handleAlboQuery(data);
        if (resp) {
            changeAlert(true, "success", "El código de autenticación fue enviado correctamente.");
            await changePage(null, 0);
        }

        setLoading(false);
    };

    const resendEmail = async (result) => {
        setLoading(true);
        let user = JSON.parse(localStorage.session);

        let data = {
            session_uuid: result["session_uuid"],
            admin_uuid: item.uuid,
            inext_user: user["email"],
        };

        let resp = await handleResendEmail(data);
        if (resp) {
            changeAlert(true, "success", "El correo fue enviado exitosamente.");
            await changePage(null, 0);
        }

        resetFields();
        setLoading(false);
    };

    const resendEmailCS = async () => {
        setLoading(true);
        let user = JSON.parse(localStorage.session);

        let data = {
            admin_uuid: item.uuid,
            inext_user: user["email"],
            auto_select_session: true,
        };

        let resp = await handleResendEmail(data);
        if (resp) {
            changeAlert(true, "success", "El correo fue enviado exitosamente.");
            await changePage(null, 0);
        }
        resetFields();
        setLoading(false);
    };

    const otpTokenGetAllowed = async (row, key) => {
        setLoading(true);
        let data = {
            admin_uuid: row.uuid,
        };

        let resp = await handleOtpTokenGetAllowed(data);
        if (resp) {
            setLoading(false);
            return onOpenConfirm(row, key);
        } else {
            changeAlert(true, "error", "El usuario no posee token vinculado.");
            setLoading(false);
        }
    };

    const otpTokenDisabledConfirm = async () => {
        setLoading(true);

        let data = {
            admin_uuid: item.uuid,
            type: "albo-token",
        };

        let resp = await HandleOtpTokenDisabledConfirm(data);
        if (resp) {
            changeAlert(true, "success", "La desvinculación se realizó de forma exitosa");
            await changePage(null, 0);
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, "error", "El usuario no posee token vinculado.");
        }
        resetFields();
    };

    const restoreSession = async (result) => {
        setLoading(true);
        let user = JSON.parse(localStorage.session);
        let data = {
            admin_uuid: item.uuid,
            session_uuid: result["session_uuid"],
            inext_user: user["email"],
            action: result["action"],
        };

        let resp = await handleRestoreSession(data);
        if (resp) {
            changeAlert(true, "success", "La acción fue ejecutada exitosamente.");
            setLoading(false);
            await changePage(null, 0);
        }
        resetFields();
        setLoading(false);
    };

    const onCloseDialogConfirm = () => {
        dialogProps.onClose();
        resetFields();
    };
    const resetFields = () => {
        setSAction("");
        setElement(null);
        setDialogText({});
        setItem(null);
    };

    return {
        item,
        loading,
        element,
        dialogText,
        dialogProps,
        onHandleConfirm,
        otpTokenGetAllowed,
        dataReuse,
        onOpenConfirm,
        onCloseDialogConfirm,
        onInsertAlboToken
    };
};
